var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { a as assignGlobalSingleton } from "../global-33d5eebf.js";
import * as PIXI from "pixi.js";
const defaultOptions = {
  xoffset: 0,
  yoffset: 0,
  width: 16,
  height: 22,
  animationSpeed: 1,
  initialRotation: 0,
  skipPixi: false,
  zIndex: 2
};
const n = (name) => name == null ? void 0 : name.toLowerCase().replace(/ /g, "_");
class ImageLoader {
  constructor() {
    __publicField(this, "imageCache", {});
    __publicField(this, "promises", []);
    __publicField(this, "pixiAssetCache", {});
  }
  static getInstance() {
    return assignGlobalSingleton("ImageLoaderInstance", () => new ImageLoader());
  }
  loadImage(name, url, imageOptions) {
    if (typeof window === "undefined") {
      return Promise.resolve({
        name: n(name),
        url,
        image: null,
        promise: null,
        ...defaultOptions,
        ...imageOptions
      });
    }
    const loadPromise = new Promise((resolve, reject) => {
      var _a;
      if (this.imageCache[n(name)]) {
        return (_a = this.imageCache[n(name)].promise) == null ? void 0 : _a.then(() => {
          resolve(this.imageCache[n(name)]);
        });
      }
      const image = new Image();
      image.src = url;
      this.imageCache[n(name)] = {
        image,
        name: n(name),
        url,
        ...defaultOptions,
        ...imageOptions ?? {},
        promise: null
      };
      image.onload = async () => {
        if (this.imageCache[n(name)].width === -1) {
          this.imageCache[n(name)].width = image.width;
        }
        if (this.imageCache[n(name)].height === -1) {
          this.imageCache[n(name)].height = image.height;
        }
        if (!this.imageCache[n(name)].skipPixi) {
          this.pixiAssetCache[n(name)] = await PIXI.Assets.load(url);
        }
        resolve(this.imageCache[n(name)]);
      };
      image.onerror = () => reject(image);
    });
    this.imageCache[n(name)].promise = loadPromise;
    this.promises.push(loadPromise);
    loadPromise.then(() => {
      this.promises = this.promises.filter((p) => p !== loadPromise);
    });
    return loadPromise;
  }
  getPixiTexture(name) {
    return this.pixiAssetCache[n(name)];
  }
  get(name) {
    if (this.promises.length) {
      throw new Error("Images not loaded");
    }
    if (!this.imageCache[n(name)]) {
      throw new Error(`Image ${n(name)} not found`);
    }
    return this.imageCache[n(name)];
  }
}
export {
  ImageLoader as default
};
//# sourceMappingURL=ImageLoader.js.map
